import { render, staticRenderFns } from "./InventoryIcon.vue?vue&type=template&id=3e550d90&scoped=true&"
import script from "./InventoryIcon.vue?vue&type=script&lang=ts&"
export * from "./InventoryIcon.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryIcon.vue?vue&type=style&index=0&id=3e550d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e550d90",
  null
  
)

export default component.exports